import { P } from "@itpi/react-components";
import React, { useState } from "react";
import { Slider } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";

interface ScoreSliderProps {
  value?: number;
  initialScore?: number;
  setScore: Function;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export const ScoreSlider: React.FC<ScoreSliderProps> = ({
  value,
  initialScore,
  setScore,
  children,
  style,
}) => {
  const labels = [
    "I can do this under direct supervision (Discover)",
    "I can do this with reduced support from others, some autonomy, and together with my peers (Explore)",
    "I can do this on my own and together with my peers (Experiment)",
    "I can do this taking and sharing some responsibilities (Dare)",
    "I can do this with some guidance and together with others (Improve)",
    "I can do this taking responsibility for making decisions and working with others (Reinforce)",
    "I can do this taking responsibility for contributing to complex developments in a specific field (Expand)",
    "I can do this contributing substantially to the development of a specific field (Transform)",
  ];
  const sliderValue = value || initialScore || 1;
  return (
    <div
      style={{
        paddingTop: 30,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <P style={{ marginBottom: 10 }}>Self Rating</P>

      <Slider
        min={1}
        max={8}
        step={1}
        value={sliderValue}
        progress
        onChange={(v) => setScore(v)}
        barClassName={value ? "sliderbar" : "sliderbar-init"}
      />
      <P style={{ textAlign: "center", marginBottom: 15, marginTop: 5 }}>
        {labels[sliderValue - 1]}
      </P>
    </div>
  );
};
